import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

export const PublishedOrDraftToggle = ({ published, setPublished }) => {
  const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setPublished(newValue);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexGrow: 1,
      }}
    >
      <ToggleButtonGroup
        value={published}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          backgroundColor: "action.hover",
          borderRadius: 999,
          p: 0.2,
          height: 35,
          "& .MuiToggleButton-root": {
            border: "none",
            borderRadius: 999,
            px: 2,
            textTransform: "none",
          },
          "& .Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
        }}
      >
        <ToggleButton value={true}>Active</ToggleButton>
        <ToggleButton value={false}>Draft</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
